import React from 'react';
import { Jumbotron, Container, Button } from 'react-bootstrap';

const HomeScreen = () => {
  return (
    <>
      <Jumbotron className='jumbotron1'>
        <Container>
          <h1>
            No-Commitment Fitness <br />
            That Fits Your Lifestyle
          </h1>
        </Container>
      </Jumbotron>
      <Jumbotron>
        <>
          <h3>Host a Class Today</h3>
          <Button variant='primary' size='lg' href='/classlist' block>
            I am a trainer
          </Button>
          <Button variant='secondary' size='lg' href='/spacelist' block>
            I own a space
          </Button>
        </>
      </Jumbotron>
      <Jumbotron>
        <>
          <h3>Sign Up for a class</h3>
          <Button variant='primary' size='lg' href='/classes' block>
            Find a class
          </Button>
        </>
      </Jumbotron>
    </>
  );
};

export default HomeScreen;
